const SectionElementName = 'data-section-id'

// HTML要素の表示時間を追跡する機能
document.addEventListener('DOMContentLoaded', () => {
  // 要素の表示時間を記録するオブジェクト
  let elementVisibilityData = new Map()

  // ページがアクティブかどうか
  let isPageActive = true

  // 最後の更新時間
  let lastUpdateTime = Date.now()

  // 最小表示時間（秒）
  const MIN_VISIBLE_TIME = 2.0

  // 要素がトラッキング対象かどうかを判定する関数
  function isTrackableSection(element) {
    return element.hasAttribute(SectionElementName)
  }

  // 要素のクラス名を取得する関数
  function getElementClassName(element) {
    return element.className || ''
  }

  // 表示時間を更新する関数
  function updateVisibilityTime(element, isVisible) {
    if (!isPageActive) return

    // 追跡するセクション要素でない場合はスキップ
    if (!isTrackableSection(element)) {
      return
    }

    const currentTime = Date.now()
    const elapsedTime = (currentTime - lastUpdateTime) / 1000 // 秒単位

    // 要素のキーを生成
    let elementKey = element.id || ''
    if (!elementKey) {
      elementKey = getElementClassName(element)
    }
    // より一意なキーを生成するために、data-section-idの値を追加
    const sectionId = element.getAttribute(SectionElementName) || ''
    elementKey = `${sectionId}_${elementKey}`

    // 表示時間を更新
    if (!elementVisibilityData.has(elementKey)) {
      elementVisibilityData.set(elementKey, {
        element: element,
        visibleTime: 0,
        isVisible: false,
        viewCount: 0,
        lastVisibleTime: 0,
      })
    }

    const data = elementVisibilityData.get(elementKey)

    // 表示状態が変わった場合のみ更新
    if (data.isVisible !== isVisible) {
      data.isVisible = isVisible

      // 表示状態がtrueになった場合、タイマーをリセット
      if (isVisible) {
        lastUpdateTime = currentTime
        data.viewCount++
        data.lastVisibleTime = currentTime
      } else {
        // 表示状態がfalseになった場合、経過時間を加算
        data.visibleTime += elapsedTime
      }
    } else if (isVisible) {
      // 表示状態が継続している場合、経過時間を加算
      data.visibleTime += elapsedTime
    }

    lastUpdateTime = currentTime
  }

  // 表示時間イベントを送信する関数
  function sendVisibilityEvent(element, data) {
    const sectionId = element.getAttribute(SectionElementName) || 'unknown'

    const eventParams = {
      page_url: window.location.href,
      page_title: document.title,
      section_id: sectionId,
      visible_second: Number(data.visibleTime.toFixed(1)),
      view_count: data.viewCount,
    }

    // GA4にイベントを送信
    if (typeof gtag === 'function') {
      gtag('event', 'section_visibility', eventParams)
    } else {
      console.log('Section visibility event:', eventParams)
    }
  }

  // ページ内のすべての要素の表示時間イベントを送信する関数
  function sendAllVisibilityEvents() {
    elementVisibilityData.forEach((data, key) => {
      if (data.visibleTime >= MIN_VISIBLE_TIME && !data.eventSent) {
        sendVisibilityEvent(data.element, data)
        data.eventSent = true
      }
    })
  }

  // Intersection Observerの設定
  const observerOptions = {
    root: null, // ビューポートを基準とする
    rootMargin: '0px',
    threshold: 0.1, // 10%以上表示されている場合にコールバックを呼び出す
  }

  // Intersection Observerのコールバック
  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      updateVisibilityTime(entry.target, entry.isIntersecting)
    })
  }

  // Intersection Observerのインスタンスを作成
  const observer = new IntersectionObserver(observerCallback, observerOptions)

  // 現在表示されている要素を確認する関数
  function checkVisibleElements() {
    document.querySelectorAll(`[${SectionElementName}]`).forEach((element) => {
      const tempObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            updateVisibilityTime(entry.target, true)
          }
        })
      }, observerOptions)

      tempObserver.observe(element)

      // 一時的なオブザーバーなので短時間で切断
      setTimeout(() => {
        tempObserver.disconnect()
      }, 5000)
    })
  }

  // 計測データを初期化する関数
  function resetTrackingData() {
    elementVisibilityData = new Map()
    lastUpdateTime = Date.now()
    checkVisibleElements()
  }

  // data-section-id属性を持つ要素のみを監視対象に追加
  const elements = document.querySelectorAll(`[${SectionElementName}]`)

  elements.forEach((element) => {
    observer.observe(element)
  })

  // 定期的に表示時間を更新（表示状態が継続している要素用）
  const visibilityInterval = setInterval(() => {
    if (!isPageActive) return

    const currentTime = Date.now()
    const elapsedTime = (currentTime - lastUpdateTime) / 1000 // 秒単位

    elementVisibilityData.forEach((data, key) => {
      if (data.isVisible) {
        data.visibleTime += elapsedTime
      }
    })

    lastUpdateTime = currentTime
  }, 1000) // 1秒ごとに更新

  // ページの可視性が変わったときの処理
  document.addEventListener('visibilitychange', () => {
    const wasActive = isPageActive
    isPageActive = document.visibilityState === 'visible'

    if (isPageActive && !wasActive) {
      // ページが非アクティブ → アクティブになった場合は再計測
      resetTrackingData()
    } else if (!isPageActive && wasActive) {
      // ページがアクティブ → 非アクティブになった場合はイベント送信
      sendAllVisibilityEvents()
    }
  })

  // ページを離れるときの処理
  window.addEventListener('pagehide', () => {
    sendAllVisibilityEvents()
    clearInterval(visibilityInterval)
    observer.disconnect()
  })

  // タブ切り替え時の処理
  window.addEventListener('blur', () => {
    isPageActive = false
    // タブから離れる際にイベントを送信
    sendAllVisibilityEvents()
  })

  window.addEventListener('focus', () => {
    isPageActive = true
    // タブに戻ってきたらデータを初期化して再計測
    resetTrackingData()
  })
})
